import { render, staticRenderFns } from "./IncidentViewHospital.vue?vue&type=template&id=bf5edba4&"
import script from "./IncidentViewHospital.vue?vue&type=script&lang=js&"
export * from "./IncidentViewHospital.vue?vue&type=script&lang=js&"
import style0 from "./IncidentViewHospital.vue?vue&type=style&index=0&id=bf5edba4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports